import { render } from "./RemarketingMix.vue?vue&type=template&id=23aa100e&scoped=true"
import script from "./RemarketingMix.vue?vue&type=script&lang=js"
export * from "./RemarketingMix.vue?vue&type=script&lang=js"

import "./RemarketingMix.vue?vue&type=style&index=0&id=23aa100e&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23aa100e"]])

export default __exports__